import { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgotPassword = ({ setForgotPass }) => {
  // State to manage email input, loading, success, and error messages
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const handleResetPassword = async () => {
    setLoading(true);
    setError(null); // Reset error state
    setSuccess(null); // Reset success state
    setFieldErrors({});
    try {
      // Prepare data for the API

      const formDataToSend = new FormData();
      formDataToSend.append('email', email);

      formDataToSend.append('endpoint', 'user/forgot-password');
      const response = await fetch('/api/form/handler', {
        method: 'POST',
        body: formDataToSend,
      });

      const responseData = await response.json();


      if (!response.ok) {
        setSuccess();
        if (response.status === 422) {
          const newFieldErrors = {};
          for (let field in responseData.errors) {
            if (responseData.errors.hasOwnProperty(field)) {
              newFieldErrors[field] = responseData.errors[field][0];
            }
          }
          setFieldErrors(newFieldErrors);
        } else {
          throw new Error(responseData.message || 'Failed to send reset password email.');
        }
        return;
      }

      // Success
      setSuccess('Password reset email sent successfully.');

      setEmail(''); // Clear the email field
      toast.success(responseData.data.text, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-4">
      <h3 className="text-white text-[24px] lg:text-[2vw] mb-3">
        Reset your password
      </h3>
      <p className="text-[#a3a3a3] leading-normal">
        Forgot your password? Type your email address below, and we will send
        you instructions to set up a new one.
      </p>

      <div className="mb-4">
        <label className="text-[13px] text-[#a3a3a3] text-start block mb-2">
          Email
        </label>
        <input
          type="email"
          className="border border-[rgba(0,0,0,0.5)] p-3 lg:p-[0.5vw] w-full text-[16px] lg:text-[1.2vw] text-black !cursor-text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {fieldErrors.email && <label className="text-red">{fieldErrors.email}</label>}
      </div>

      <div className="pt-2 flex justify-between items-center gap-4">
        <button
          className="border-none bg-[#a3a3a3] text-black py-2 px-5 font-semibold !cursor-pointer hover:bg-white"
          onClick={handleResetPassword}
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Reset Password'}
        </button>

        <div className="leading-normal text-[#a3a3a3] table">
          <span
            className="hover:text-white !cursor-pointer"
            onClick={() => setForgotPass(false)}
          >
            Back to Login
          </span>
        </div>
      </div>

      {/* Display Success or Error Messages */}
      {success && <div className="text-green mt-2">{success}</div>}
      {error && <div className="text-red mt-2">{error}</div>}
    </div>
  );
};

export default ForgotPassword;
